import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface DeveloperToolsRouteProps {
  children?: React.ReactNode;
}

export const DeveloperToolsRoute: React.FC<DeveloperToolsRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check for developer tools view permission
  if (!hasPermission('developer_tools.view')) {
    return <Navigate to="/" replace />;
  }

  return <>{children || <Outlet />}</>;
};
